import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { validate, getLangDir } from 'wix-rich-content-common';
import verticalEmbedSchema from 'wix-rich-content-common/dist/statics/schemas/vertical-embed.schema.json';
import classnames from 'classnames';
import { s as styles } from './CardContent-c19b421c.js';
import { VERTICAL_EMBED_TYPE } from './types.js';
import { verticalsDataBuilder } from './verticalsDataBuilder.js';
import Card from './components/Card.js';
import './style-inject.es-746bb8ed.js';
import 'wix-rich-content-common/libs/Tooltip';
import './constants.js';
import 'ricos-schema';
import './convertDuration.js';
import 'lodash';
import 'wix-rich-content-common/libs/imageUtils';

var __defProp = Object.defineProperty;
var __defProps = Object.defineProperties;
var __getOwnPropDescs = Object.getOwnPropertyDescriptors;
var __getOwnPropSymbols = Object.getOwnPropertySymbols;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __propIsEnum = Object.prototype.propertyIsEnumerable;
var __defNormalProp = (obj, key, value) => key in obj ? __defProp(obj, key, { enumerable: true, configurable: true, writable: true, value }) : obj[key] = value;
var __spreadValues = (a, b) => {
  for (var prop in b || (b = {}))
    if (__hasOwnProp.call(b, prop))
      __defNormalProp(a, prop, b[prop]);
  if (__getOwnPropSymbols)
    for (var prop of __getOwnPropSymbols(b)) {
      if (__propIsEnum.call(b, prop))
        __defNormalProp(a, prop, b[prop]);
    }
  return a;
};
var __spreadProps = (a, b) => __defProps(a, __getOwnPropDescs(b));
var __publicField = (obj, key, value) => {
  __defNormalProp(obj, typeof key !== "symbol" ? key + "" : key, value);
  return value;
};
class VerticalEmbedComponent extends PureComponent {
  constructor(props) {
    super(props);
    __publicField(this, "onClick", () => {
      var _a, _b;
      return (_b = (_a = this.props.helpers).onViewerAction) == null ? void 0 : _b.call(
        _a,
        VERTICAL_EMBED_TYPE,
        "Click",
        this.props.componentData.type
      );
    });
    validate(props.componentData, verticalEmbedSchema);
  }
  render() {
    const {
      componentData,
      className,
      settings: { slimLayout = false, changeBaseUrl, disabled = false },
      t,
      locale
    } = this.props;
    const { selectedProduct, type } = componentData;
    const props = verticalsDataBuilder(type, selectedProduct, t, changeBaseUrl);
    const direction = getLangDir(locale);
    return (
      // eslint-disable-next-line jsx-a11y/click-events-have-key-events
      /* @__PURE__ */ React.createElement(
        "div",
        {
          className: classnames(className, styles.card, { [styles.slimLayout]: slimLayout }),
          "data-hook": "vertical-embed",
          onClick: this.onClick
        },
        /* @__PURE__ */ React.createElement(Card, __spreadProps(__spreadValues({}, props), { t, direction, disabled }))
      )
    );
  }
}
VerticalEmbedComponent.propTypes = {
  componentData: PropTypes.object.isRequired,
  className: PropTypes.string,
  settings: PropTypes.object,
  helpers: PropTypes.object,
  locale: PropTypes.string,
  t: PropTypes.func
};

export { VerticalEmbedComponent as default };
//# sourceMappingURL=vertical-embed-component.js.map
